import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";

const Modal = ({ isShowing, hide, rates, updateRate }) => {
  const [rodp, handlerodp] = useState(0);
  const [count, handleCount] = useState(1);
  const [customRodp, handleCustomRodp] = useState(10);
  const [minValue, handleMinValue] = useState(0);
  const [startTime, handlestartTime] = useState(0);
  const [endTime, handleendTime] = useState(0);
  const [disable, handleDisable] = useState("disableButton");
  useEffect(() => {
    if (count === 1) {
      handlerodp(rates.rodpRate ? rates.rodpRate : 0);
      handleMinValue(rates.minValue ? rates.minValue : 0);
      handleCustomRodp(rates.customRodpRate ? rates.customRodpRate : 10);
      handlestartTime(rates.startTime ? rates.startTime : "");
      handleendTime(rates.endTime ? rates.endTime : "");
    }
  });
  const handleStartDate = (date) => {
    handlestartTime(date);
    handleCount(count + 1);
  };
  const handleEndDate = (date) => {
    handleendTime(date);
    handleCount(count + 1);
  };
  const getRodp = (e) => {
    if (
      Number(e.target.value) <= 2000 &&
      e.target.value.length > 0 &&
      e.target.value[0] != "-" &&
      ((Number(e.target.value) < 10 && e.target.value.length <= 4) ||
        (Number(e.target.value) >= 10 && e.target.value.length <= 5) ||
        (Number(e.target.value) >= 100 && e.target.value.length <= 6) ||
        (Number(e.target.value) >= 1000 && e.target.value.length <= 7))
    ) {
      handlerodp(Number(e.target.value));
    } else if (e.target.value === "") {
      handlerodp("");
    }
    handleCount(count + 1);
    handleDisable("");
  };
  const getCustomRodp = (e) => {
    if (
      Number(e.target.value) <= 2000 &&
      e.target.value.length > 0 &&
      e.target.value[0] != "-" &&
      ((Number(e.target.value) < 10 && e.target.value.length <= 4) ||
        (Number(e.target.value) >= 10 && e.target.value.length <= 5) ||
        (Number(e.target.value) >= 100 && e.target.value.length <= 6) ||
        (Number(e.target.value) >= 1000 && e.target.value.length <= 7))
    ) {
      handleCustomRodp(Number(e.target.value));
    } else if (e.target.value === "") {
      handleCustomRodp("");
    }
    handleCount(count + 1);
    handleDisable("");
  };
  const getMinValue = (e) => {
    if (e.target.value) {
      handleMinValue(Number(e.target.value));
    } else if (e.target.value === "") {
      handleMinValue("");
    }
    handleCount(count + 1);
    handleDisable("");
  };
  const closePopup = () => {
    hide();
    handleCount(1);
  };

  const updateRates = (e) => {
    e.preventDefault();
    if (rodp === "" && !toast.isActive("1")) {
      toast.error("Please enter valid number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    if (Number(rodp) < 10 && !toast.isActive("1")) {
      toast.error("amount must be in between 10 to 2000", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    if (Number(customRodp) < 1 && !toast.isActive("1")) {
      toast.error("Custom amount must be in between 10 to 2000", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    } else if (rodp === "" || Number(rodp) < 10) {
      return;
    }
    else if(!startTime){
      toast.error("Please provide a station start time", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    else if(!endTime){
      toast.error("Please provide a station end time", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    const params = {
      _id: rates._id,
      rodp: Number(rodp),
      customRodp: Number(customRodp),
      minValue: Number(minValue),
      startTime: +new Date(startTime),
      endTime: +new Date(endTime)
    };
    handleCount(1);
    updateRate(params);
  };

  return isShowing ? (
    <div>
      <div className="modal-overlay">
        <div
          className="modal-wrapper thankyou-popup"
          aria-modal
          aria-hidden
          tabIndex={-1}
          role="dialog"
        >
          <div className="modal">
            <div className="modal-head-cross rate-modal">
              <button
                type="button"
                className="modal-close-button"
                onClick={closePopup}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="editNonFct-header modal-header">
                <h4 className="popup-head rqst-head fct-head modal-title">
                  Edit Rate Card
                </h4>
              </div>
              <div className="editNonFct-modal modal-body">
                <div className="bg-white">
                  <form className="form-group">
                    <div className="popupCampaign-container">
                      <div className="campaign-input master-inputs nonFct">
                        <div className="input-tag signup-tag clearfix fct-input">
                          <label className="static-value">Region</label>
                          <input
                            name="stationName"
                            type="text"
                            className="form-control"
                            value={rates.region}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="campaign-input master-inputs nonFct">
                        <div className="input-tag signup-tag clearfix fct-input">
                          <label className="static-value">Station</label>
                          <input
                            name="trafficUpdate"
                            type="text"
                            className="form-control"
                            value={rates.station}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="campaign-input master-inputs nonFct">
                        <div className="input-tag signup-tag clearfix fct-input">
                          <label className="static-value">State</label>
                          <input
                            name="weatherUpdate"
                            type="text"
                            className="form-control"
                            value={rates.state}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="campaign-input master-inputs nonFct">
                        <div className="input-tag signup-tag clearfix fct-input">
                          <label className="static-value">RODP</label>
                          <input
                            name="stockUpdate"
                            type="number"
                            className="form-control"
                            value={rodp}
                            onChange={getRodp}
                          />
                        </div>
                      </div>
                      <div className="campaign-input master-inputs nonFct">
                        <div className="input-tag signup-tag clearfix fct-input">
                          <label className="static-value">Custom Premium</label>
                          <input
                            name="stockUpdate"
                            type="number"
                            className="form-control"
                            value={customRodp}
                            onChange={getCustomRodp}
                          />
                        </div>
                      </div>
                      <div className="campaign-input master-inputs nonFct">
                        <div className="input-tag signup-tag clearfix fct-input">
                          <label className="static-value">Min Value</label>
                          <input
                            name="stockUpdate"
                            type="number"
                            className="form-control"
                            value={minValue}
                            onChange={getMinValue}
                          />
                        </div>
                      </div>
                      <div className="campaign-input master-inputs nonFct">
                        <div className="input-tag signup-tag clearfix fct-input">
                          <label className="static-value">
                            Station Start Time
                          </label>
                          <div style={{ marginLeft: "35%" }}>
                            <DatePicker
                              // placeholderText="Select Start Time"
                              dateFormat="h:mm a"
                              onChange={handleStartDate}
                              selected={startTime}
                              showTimeSelect
                              // className="form-control"
                              showTimeSelect
                              showTimeSelectOnly
                              timeIntervals={60}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="campaign-input master-inputs nonFct">
                        <div className="input-tag signup-tag clearfix fct-input">
                          <label className="static-value">
                            Station End Time
                          </label>
                          <div style={{ marginLeft: "35%" }}>
                            <DatePicker
                              dateFormat="h:mm a"
                              onChange={handleEndDate}
                              selected={endTime}
                              showTimeSelect
                              className="form-control"
                              showTimeSelect
                              showTimeSelectOnly
                              timeIntervals={60}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="create-camp nonfct-submit">
                        <button className={disable} onClick={updateRates}>
                          SAVE CHANGES
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="modal-footer cost_button">
         <button className="cncl">Cancel</button>
         <button className="procd">Ok</button>
        </div> */}
        </div>
      </div>
      <ToastContainer />
    </div>
  ) : null;
};

export default Modal;



// WEBPACK FOOTER //
// ./web/components/admin/common/model.js